
"use client";

import clsx from "clsx";
import { BrandIconsJSON, BrandIconsJSONNew } from "@/data/data";
import { useCallback, useRef, useState } from "react";
import styles from "./Styles.module.scss";
import ArrowIcon from "@/SvgIcons/ArrowIcon";
import { imgPathReplace } from "@/helpers/imgPathReplace";
import Carousel from "@/components/molecules/CustomCarousels/Carousel";

export default function BrandWrapper({ isSpecificPage = false }) {
  const brandIcons = isSpecificPage ? BrandIconsJSONNew : BrandIconsJSON;
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);
  const sliderRef = useRef(null);
  const handlePrev = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.prevSlide();
  }, []);

  const handleNext = useCallback(() => {
    if (!sliderRef.current) return;
    sliderRef.current.nextSlide();
  }, []);

  const handleSlideChange = (swiper) => {
    setIsAtStart(swiper.isBeginning);
    setIsAtEnd(swiper.isEnd);
  };

  return (
    <>
      <Carousel
        children={brandIcons.map((icon, index) => (
          <div className={clsx(styles.recitem, "p-2")} key={index}>
            <img
              src={imgPathReplace(icon.src)}
              srcSet={imgPathReplace(icon.src)}
              alt={icon.alt}
              title={icon.title}
              className="w-100 object-contain"
              height={230}
              width={230}
              loading="lazy"
            />
          </div>
        ))}
        ref={sliderRef} 
        config={{
          speed: 400,
          spaceBetween: 1,
          slidesPerView: 6,
          isGrid: true,
          grid: { rows: 3, fill: "row" },
          pagination: {
            status: false
          },
          autoplay: {
            status: false
          },
          breakpoints: {
            0: {
              slidesPerView: 2,
              grid: { rows: 3, fill: "row" },
            },
            481: {
              slidesPerView: 4,
              grid: { rows: 3, fill: "row" },
            },
            769: {
              slidesPerView: 6,
              grid: { rows: 3, fill: "row" },
            }
          },
          onSlideChange: ({isBeginning, isEnd}) => handleSlideChange({ isBeginning, isEnd}),
          pageType: "logo"
        }}
      />

      <button
        className={clsx(
          styles.swiperButtonPrev,
          "absolute",
          isAtStart && "disabled"
        )}
        onClick={handlePrev}
        disabled={isAtStart}
        aria-label="Previous"
      >
        <ArrowIcon direction="left" size={30} color="#b6b6b6" />
      </button>
      <button
        className={clsx(styles.swiperButtonNext, "absolute -rotate-180", isAtEnd && "disabled")}
        onClick={handleNext}
        aria-label="Next"
        disabled={isAtEnd}
      >
        <ArrowIcon direction="right" size={30} color="#b6b6b6" />
      </button>

    </>
  )
}
